Vue.component('ack-navbar', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-navbar',
	mounted() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.handleScroll);
		this.handleResize();
		setTimeout(() => {
			this.switchMenuIcons(true);
		}, 500);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.handleScroll);
	},
	computed: {
		...Vuex.mapGetters('navBar', ['mainMenuData']),
		...Vuex.mapGetters('localization', ['countryCode', 'isUS_CA', 'regions', 'isIreland', 'isTW']),
		isMobile() {
			return this.$parent.isMobile;
		},

		storeAvailable() {
			let avl = true;
			if (
				this.countryCode.toUpperCase() == 'US' ||
				this.countryCode.toUpperCase() == 'CA' ||
				this.isIreland
			) {
				avl = false;
			}
			return avl;
		},

		menuDataHandler() {
			let menus = this.mainMenuData.filter((menu) => !menu.hidden);
			const usaCaMenuHandler = () => {
				menus = menus.map((menu) => {
					if (menu.title === 'Products') {
						return {
							...menu,
							items: menu.items?.filter(
								(item) => !['UV Box', 'CLEANI with Tank Plus', 'DENTIQ'].includes(item.title),
							),
						};
					}
					return menu;
				});
			};
			this.isUS_CA && usaCaMenuHandler();
			menus = [...this.getExtendedConciergePdfUrl(menus)];

			return menus;
		},
		quoteBtnConfig() {
			const btnName = this.isUS_CA ? 'Schedule a Demo' : 'Get a Quote';
			const link = this.isUS_CA
				? 'https://share.hsforms.com/1ZcPPapeqR0WvgDbLu68kXQ1gyw6'
				: '/pages/get-a-quote';
			return {
				name: btnName,
				link,
			};
		},
	},
	data() {
		return {
			showMenu: false,
			windowInnerWidth: null,
			mobileMenuOpened: false,

			lastScrollTop: 0,
			mainNavBarIconsHidden: false,
			scrollTicking: false,
		};
	},
	methods: {
		...Vuex.mapActions('navBar', ['closeAllMobileDropdowns']),

		showOffcanvasMenu() {
			this.mobileMenuOpened = !this.mobileMenuOpened;
		},
		handleResize() {
			this.windowInnerWidth = window.innerWidth;

			let elements = document.getElementsByClassName('dropdown-items');

			for (let index = 0; index < elements.length; index++) {
				const element = elements[index];
				let width = this.windowInnerWidth - 50;
				// Set the width in pixels
				element.style.width = width + 'px';
			}
		},

		switchMenuIcons(show) {
			if (show) {
				this.mainNavBarIconsHidden = false;
			} else {
				this.mainNavBarIconsHidden = true;
			}
		},

		showHideMenuIcons(currentScrollTop) {
			if (currentScrollTop > this.lastScrollTop) {
				// Scrolling down
				this.switchMenuIcons(false);
			}

			this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
		},

		handleScroll() {
			let currentScrollTop = window.scrollY; // window.pageYOffset || document.documentElement.scrollTop

			if (!this.scrollTicking) {
				this.scrollTicking = true;
				setTimeout(() => {
					window.requestAnimationFrame(() => {
						this.showHideMenuIcons(currentScrollTop);
						// this.scrollTicking = false
						setTimeout(() => {
							this.scrollTicking = false;
						}, 200);
					});
				}, 200);
			}

			//this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
		},

		onOpenMenuHandler(item) {
			// this.closeAllMobileDropdowns()
		},

		showCountrySelector() {
			appLog.log('showCountrySelector in', LOG_TYPE.debug);
			EventBus.$emit('show-country-selector-modal');
		},
		hideCountrySelector() {
			EventBus.$emit('hide-country-selector-modal');
		},
		getExtendedConciergePdfUrl(menus) {
			const data = Array.from(menus);
			const isServices = (menu) => menu.title === 'Services';
			const isExtendedConcierge = (item) => item.title === 'Extended Coverage';
			data.find(isServices).items.find(isExtendedConcierge).url = getExtendedConciergePdf(
				this.regions,
			);

			return data;
		},
	},
	watch: {},
});
